<script>

export default {
  props: {
    contact: {type: Object, required: true},
  },

  data() {
    return {
      observed: this.$storage.observed,
      directChannel: this.$storage.getDirectChannel(this.contact.mmid)
    }
  },

  watch: {
    'observed.directChannels': function (newVal, oldVal) {
      let me = this
      setTimeout(function() {
        me.directChannel = me.$storage.getDirectChannel(me.contact.mmid)
      }, 500);
    }
  },

  methods: {
    displayName(contact) {
      return `${contact.last_name || ''} ${contact.first_name || ''}`.trim() || contact.username
    }
  }
}

</script>

<template>

  <div class="list-group-item">
      <div class="d-flex flex-row align-items-center">
        <img :src="contact.profile_image" class="avatar me-2" />
        <div>
          <h4 class="card-title mb-0">
            {{displayName(contact)}}
          </h4>
          <div class="text-muted">
            <small>{{contact.company_name}}</small>
          </div>
        </div>
        <div v-if="directChannel && directChannel.numUnreadMessages"
         class="badge badge-danger ml-auto">
          <i class="far fa-envelope"></i> {{directChannel.numUnreadMessages}}
        </div>
      </div>
  </div>

</template>

<style scoped>

.avatar {
  height:30px;
  width:30px;
  object-fit:cover;
  border-radius:50%;
  overflow:hidden;
}

.badge {
  border-radius: .5rem;
  height: fit-content;
}

</style>